import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import {
  useIsReportBaseTemplate,
  useIsReportCompleted,
  useIsReportHandlebars,
  useIsReviewPage,
} from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION, RECOMMENDATIONS_PAGE_LOCATION } from "@components/ReportField/consts";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

// Whether the field title (label) is editable. Reproduces the legacy
// SectionWidgetWrapper `canEditTitle` per surface (inline-edit treated as off).
export const useCanEditFieldTitle = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const { isCatalightUser } = useAdminData();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();
  const isHandlebars = useIsReportHandlebars();
  const isBaseTemplate = useIsReportBaseTemplate();

  const reportType = report.reportType;
  const onAppendix = section.pageLocation === APPENDIX_PAGE_LOCATION;
  const onRecommendations = section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION;

  if (isCompleted) return false;
  if (isReviewPage) return false;

  if (reportType === ApiReportReportTypeChoices.InitialAssessment) {
    return true;
  }
  if (reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    return isBaseTemplate || onAppendix || onRecommendations;
  }

  // clinical
  if (isHandlebars) return true;
  if (onRecommendations && isCatalightUser) return false;

  const appendixSupported = reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "single";
  return onRecommendations || (appendixSupported && onAppendix);
};
